import React from 'react'
import { Card, Text, Button, Note, Grid } from '@geist-ui/react'
import EnrollmentHeader from '../../EnrollmentHeader'

export default function ReasonInfoCard({
  reasonInfo,
  showLoginButton,
  children,
}) {
  return (
    <Grid.Container>
      <Grid direction="column">
        <EnrollmentHeader
          title={reasonInfo.title}
          description={reasonInfo.description}
        />
        <Card
          shadow
          style={{
            marginTop: '2rem',
            maxWidth: '600px',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginBottom: '2rem',
          }}
        >
          {reasonInfo.message && (
            <Text
              p
              style={{
                marginBottom: showLoginButton ? '1.5rem' : '0',
              }}
            >
              {reasonInfo.message}
            </Text>
          )}
          {children}
          {showLoginButton && (
            <Button
              type="success"
              size="large"
              onClick={() => {
                window.location.href = '/auth'
              }}
              style={{ marginTop: '1rem' }}
            >
              Log In
            </Button>
          )}
          <Note type="warning" style={{ marginTop: '1rem' }}>
            Need help? Contact support at <strong>888-977-7481</strong> or{' '}
            <strong>info@waterproplan.com</strong>.
          </Note>
        </Card>
      </Grid>
    </Grid.Container>
  )
}
